enum DateType {
    MONTH = 0,
    DAY = 1
}

export default DateType;